module.exports = __webpack_public_path__ + "img/home_service_price.f79fef02.png";